<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="项目名称:" :label-width="78" prop="projectName">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地:" prop="areaCode">
                        <place-select v-model="formInline.areaCode"></place-select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="所属企业:" prop="corpName">
                        <Input v-model="formInline.corpName" placeholder="请输入所属企业"></Input>
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
                <Col span="6">
                    <FormItem label="班组名称:" :label-width="78" prop="teamName">
                        <Input v-model="formInline.teamName" placeholder="请输入班组名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6" class="aFlex">
                    <!--<Col span="6">-->
                        <FormItem label="工资年份:" prop="year" :label-width="80" >
                            <DatePicker type="year" placeholder="工资年份" :value="formInline.year"  @on-change='formInline.year=$event'></DatePicker>
                        </FormItem>
                    <!--</Col>-->
                    <FormItem label="月份:" prop="month" :label-width="60" >
                        <DatePicker type="month" placeholder="工资月份" :value="formInline.month"  @on-change='formInline.month=$event'></DatePicker>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="人员姓名:" prop="workerName">
                        <Input v-model="formInline.workerName" placeholder="请输入人员姓名"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
                <Col span="6">
                    <FormItem label="证件号码:" :label-width="78" prop="idCardNum">
                        <Input v-model="formInline.idCardNum" placeholder="请输入证件号码"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="工资卡开户行:" prop="payRollBankName">
                        <Input v-model="formInline.payRollBankName" placeholder="请输入工资卡开户行"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="工资代发开户行:" prop="payBankName">
                        <Input v-model="formInline.payBankName" placeholder="请输入工资代发开户行"></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="8">
                    <Button :loading="eLoading" style="margin-bottom: 24px;" icon="ios-exit-outline" type="primary" @click="handleExport">导出</Button>
                </Col>
            </Row>
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('workerWageDetail',row)">详情</span>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<script>
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                id: '',
                formInline:{
                    projectName: '',
                    areaCode: localStorage.getItem('tenantAreaCode'),// 地区
                    corpName: '',
                    teamName: '',
                    year: '',
                    month: '',
                    workerName: '',
                    idCardNum: '',
                    payRollBankName: '',
                    payBankName: '',
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '项目名称', key: 'projectName', minWidth: 150, tooltip: true },
                    { title: '项目所在地', key: 'areaName', minWidth: 100, tooltip: true },
                    { title: '所属企业', key: 'corpName', minWidth:100, tooltip: true },
                    { title: '班组名称', key: 'teamName', minWidth: 100, tooltip: true },
                    { title: '人员姓名', key: 'workerName', minWidth: 100, tooltip: true },
                    { title: '证件类型', key: 'idCardType', minWidth: 100, tooltip: true },
                    { title: '证件号码', key: 'idCardNumber', minWidth: 150, tooltip: true },
                    { title: '性别', key: 'gender', minWidth: 100, tooltip: true },
                    { title: '年龄', key: 'age', minWidth: 100, tooltip: true },
                    { title: '联系电话', key: 'cellPhone', minWidth: 100, tooltip: true },
                    { title: '人员类型', key: 'workTypeName', minWidth: 100, tooltip: true },
                    { title: '岗位类型', key: 'manageTypeName', minWidth: 100, tooltip: true },
                    { title: '工资月份', key: 'payMonth', minWidth: 100, tooltip: true },
                    { title: '出勤天数', key: 'days', minWidth: 100, tooltip: true },
                    { title: '总工时', key: 'workHours', minWidth: 100, tooltip: true },
                    { title: '应发金额', key: 'totalPayAmount', minWidth: 100, tooltip: true },
                    { title: '实发金额', key: 'actualAmount', minWidth: 100, tooltip: true },
                    { title: '是否补发', key: 'isBackPay', minWidth: 100, tooltip: true },
                    { title: '发放日期', key: 'balanceDate', minWidth: 100, tooltip: true },
                    { title: '补发月份', key: 'backPayMonth', minWidth: 100, tooltip: true },
                    { title: '工人工资卡号', key: 'payRollBankCardNumber', minWidth: 150, tooltip: true },
                    { title: '工人工资卡开户行名称', key: 'payRollBankName', minWidth: 150, tooltip: true },
                    { title: '工资代发银行卡号', key: 'payBankCardNumber', minWidth: 150, tooltip: true },
                    { title: '工资代发银行名称', key: 'payBankName', minWidth: 150, tooltip: true },
                    { title: '第三方工资单编号', key: 'thirdPayRollCode', minWidth: 150, tooltip: true },
                    { title: '操作', slot: 'action', fixed: 'right', align: 'center', minWidth:100 }
                ],
                tableData: [],
            };

        },
        computed:{
        },
        created(){
            this.id= this.$route.params.id
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            disabledDateStart(val) {
                return val.getTime() > (Date.now() - 86400000);
            },
            handleReset() {
                this.pageSize = 10;
                this.page = 1;
                this.formInline.projectName = ''
                this.formInline.corpName = ''
                this.formInline.teamName = ''
                this.formInline.year = ''
                this.formInline.month = ''
                this.formInline.workerName = ''
                this.formInline.idCardNum = ''
                this.formInline.payRollBankName = ''
                this.formInline.payBankName = ''
                this.formInline.areaCode = localStorage.getItem('tenantAreaCode');
                this.getTableData()
            },
            // 导出
            handleExport(){
                const params = {
                    size: this.pageSize,
                    current: this.page,
                    id: this.id,
                };
                Object.assign(params, this.formInline);
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/summary/sx/payOffDetail/export',
                    responseType:'arraybuffer',
                    data: params,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'工资单.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name, row){
                this.$router.push({
                    name: name,
                    query: {
                        row
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                const params = {
                    size: this.pageSize,
                    current: this.page,
                    id: this.id,
                };
                Object.assign(params, this.formInline);
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/summary/sx/payOffDetail/pageList',
                    data: params
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.records
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
